export const resources = {
  ja: {
    translation: {
      language: { ja: '日本語', en: 'English' },
      login: {
        eyebrow: 'One team, many places',
        headline: 'Your day\nstarts here.',
        description: 'シフト、勤怠、休み希望、日々のオペレーション。\nPeche et Fleurのチームをつなぐスタッフポータルです。',
        greeting: '今日も、いい一日に。',
        prompt: 'スタッフアカウントでログインしてください。',
        email: 'メールアドレス',
        password: 'パスワード',
        passwordPlaceholder: 'パスワードを入力',
        submit: 'ログイン',
        submitting: '認証中…',
        checking: '確認中…',
        required: 'メールアドレスとパスワードを入力してください',
        invalidEmail: '正しいメールアドレスを入力してください',
        invalidCredentials: 'メールアドレスまたはパスワードが正しくありません',
        timeout: '接続に時間がかかっています。もう一度お試しください。',
        showPassword: 'パスワードを表示',
        hidePassword: 'パスワードを隠す',
      },
      nav: {
        menu: 'メニュー', home: '全社TOP', casa: 'Casa Kokoro', casaOperations: 'Casaオペレーション', dashboard: 'ダッシュボード', reservations: '予約管理', cleaning: '清掃管理',
        attendance: '勤怠管理', availability: '休み希望', shifts: 'シフト', staff: 'スタッフ管理',
        reports: 'レポート', profitLoss: '部門別損益', goldysClosing: 'Goldy’s 日次締め', purchaseRequests: '発注依頼', receivables: '売掛・入金管理', payables: '買掛・支払管理', reimbursements: '個人立替・精算', dailyPay: '日払い精算', contracts: '部門別契約台帳', notifications: '通知', messages: 'メッセージ', account: 'アカウント設定', settings: '設定', admin: '管理者',
        frontDesk: 'フロント', teamMember: 'スタッフ', logout: 'ログアウト', openMenu: 'メニューを開く', closeMenu: 'メニューを閉じる',
      },
      profitLoss: {
        title:'部門別損益', subtitle:'各事業の月次収益と費用を一つの画面で管理します。', add:'明細を追加', edit:'明細を編集',
        revenue:'収益', cost:'売上原価', labor:'人件費', expense:'その他経費', profit:'営業利益', grossProfit:'粗利益',
        department:'部門', departmentSummary:'部門別サマリー', entries:'月次明細', noEntries:'この月の明細はまだありません。', loading:'読み込み中…',
        date:'日付', classification:'区分', category:'科目', categoryPlaceholder:'例：宿泊売上、燃料費', amount:'金額（円）', notes:'メモ', save:'保存', saving:'保存中…', auto:'自動連携',
        loadError:'損益データを読み込めませんでした。', saveError:'明細を保存できませんでした。', deleteError:'明細を削除できませんでした。', deleteConfirm:'この明細を削除しますか？',
        types:{revenue:'売上',other_income:'その他収益',cost_of_sales:'売上原価',labor:'人件費',operating_expense:'その他経費'}
      },
    },
  },
  en: {
    translation: {
      language: { ja: '日本語', en: 'English' },
      login: {
        eyebrow: 'One team, many places',
        headline: 'Your day\nstarts here.',
        description: 'Shifts, attendance, time-off requests and daily operations.\nA staff portal that keeps the Peche et Fleur team connected.',
        greeting: 'Make today a great day.',
        prompt: 'Sign in with your staff account.',
        email: 'Email address',
        password: 'Password',
        passwordPlaceholder: 'Enter your password',
        submit: 'Sign in',
        submitting: 'Signing in…',
        checking: 'Checking your account…',
        required: 'Enter your email address and password.',
        invalidEmail: 'Enter a valid email address.',
        invalidCredentials: 'The email address or password is incorrect.',
        timeout: 'The connection is taking longer than expected. Please try again.',
        showPassword: 'Show password',
        hidePassword: 'Hide password',
      },
      nav: {
        menu: 'Menu', home: 'Company home', casa: 'Casa Kokoro', casaOperations: 'Casa operations', dashboard: 'Dashboard', reservations: 'Reservations', cleaning: 'Housekeeping',
        attendance: 'Attendance', availability: 'Time-off requests', shifts: 'Shifts', staff: 'Staff management',
        reports: 'Reports', profitLoss: 'Department P&L', goldysClosing: 'Goldy’s Daily Close', purchaseRequests: 'Purchase Requests', receivables: 'Receivables', payables: 'Accounts Payable', reimbursements: 'Reimbursements', dailyPay: 'Daily Pay', contracts: 'Department Contracts', notifications: 'Notifications', messages: 'Messages', account: 'Account', settings: 'Settings', admin: 'Administrator',
        frontDesk: 'Front desk', teamMember: 'Team member', logout: 'Sign out', openMenu: 'Open menu', closeMenu: 'Close menu',
      },
      profitLoss: {
        title:'Department P&L', subtitle:'Manage monthly revenue and costs across every business.', add:'Add entry', edit:'Edit entry',
        revenue:'Revenue', cost:'Cost of sales', labor:'Labor', expense:'Other expenses', profit:'Operating profit', grossProfit:'Gross profit',
        department:'Department', departmentSummary:'Department summary', entries:'Monthly entries', noEntries:'No entries for this month.', loading:'Loading…',
        date:'Date', classification:'Type', category:'Account', categoryPlaceholder:'e.g. Accommodation sales, Fuel', amount:'Amount (JPY)', notes:'Notes', save:'Save', saving:'Saving…', auto:'Synced',
        loadError:'Could not load P&L data.', saveError:'Could not save the entry.', deleteError:'Could not delete the entry.', deleteConfirm:'Delete this entry?',
        types:{revenue:'Revenue',other_income:'Other income',cost_of_sales:'Cost of sales',labor:'Labor',operating_expense:'Other expense'}
      },
    },
  },
} as const;
